// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetSubscriptionArticlesRequestModel from '../../model/get-subscription-articles-request-model';
import GetSubscriptionArticlesRequestDTO from '../dto/get-subscription-articles-request-dto';
import dtoSchema from '../schemas/get-subscription-articles-request-schema';

export default abstract class GetSubscriptionArticlesRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetSubscriptionArticlesRequestDTO>) {
    super();
    if (data) {
      this.subscriptionType = data.subscriptionType;
    }
  }
  /**
  * @type {int32}
  */
  subscriptionType?: 1 | 2; // SubscriptionTypeDTO

  static toModel(dto: DeepPartial<GetSubscriptionArticlesRequestDTO>): GetSubscriptionArticlesRequestModel;
  static toModel(dto: DeepPartial<GetSubscriptionArticlesRequestDTO> | undefined | null): GetSubscriptionArticlesRequestModel | undefined;
  static toModel(dto: DeepPartial<GetSubscriptionArticlesRequestDTO> | undefined | null): GetSubscriptionArticlesRequestModel | undefined {
    return dto ? new GetSubscriptionArticlesRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetSubscriptionArticlesRequestModel> | GetSubscriptionArticlesRequestModel): GetSubscriptionArticlesRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      subscriptionType: unwrapped.subscriptionType,
    } as GetSubscriptionArticlesRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetSubscriptionArticlesRequestModel, can not map to GetSubscriptionArticlesRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
